import { useUtils } from '@/lib/hooks/utils'
import { RemovaCharEspeciais } from '@/utils/format'
import { useClientContext } from '@/context/client'

export function useCnpjLookup() {
  const {
    setClientMode,
    setInformacoes,
    setInformacoesCnpj,
    setCarregando,
    setRegimeTributario,
    setProdutosSelecionados,
    setConcordo,
    setPossui,
    setClienteData,
    setContadorData,
    setBancoData,
    setSenhaProprietario,
    setCustomComissao,
    setComissaoEscrita,
    setMostrarCampos,
    setMostrarCamposContador,
    setIsMinutaEnviada,
    setIsClienteCriado,
    setVerificacaoConcluida
  } = useClientContext()

  const { buscarCNPJ, buscarCEP } = useUtils()

  const handleSubmit = async (cnpjValue: string) => {
    // Reset all form state
    setInformacoes(null)
    setInformacoesCnpj(null)
    setClientMode(null)
    setRegimeTributario(null)
    setProdutosSelecionados([])
    setConcordo(false)
    setPossui(false)
    setClienteData(null)
    setContadorData({ name: '', email: '', whatsapp: '' })
    setBancoData({ banco: '', agencia: '', conta: '' })
    setSenhaProprietario('')
    setCustomComissao('')
    setComissaoEscrita('')
    setMostrarCampos(false)
    setMostrarCamposContador(false)
    setIsMinutaEnviada(false)
    setIsClienteCriado(false)
    setVerificacaoConcluida(false)
    setCarregando(true)

    try {
      const id_client = RemovaCharEspeciais(cnpjValue)
      const response = await buscarCNPJ(id_client)
      response.cnpj = id_client

      const normalizedCep = RemovaCharEspeciais(response.cep || '')
      if (normalizedCep) {
        const cepResponse = await buscarCEP(normalizedCep)
        if (cepResponse) {
          response.cep = cepResponse.cep || response.cep
          response.logradouro = cepResponse.logradouro || response.logradouro
          response.bairro = cepResponse.bairro || response.bairro
          response.complemento = cepResponse.complemento || response.complemento
          response.uf = cepResponse.uf || response.uf
          response.estado = cepResponse.uf || response.estado
          response.municipio = cepResponse.localidade || response.municipio
          response.localidade = cepResponse.localidade || response.localidade
        }
      }

      setInformacoesCnpj(response)

      const atividadePrincipal = response.atividade_principal[0]
      if (response) {
        const dadosCNPJ = {
          razao_social: response.nome,
          cnae: `${atividadePrincipal.code}, ${atividadePrincipal.text}`,
          endereco: `${response.logradouro}, ${response.numero}, ${response.bairro}, ${response.uf}, ${response.cep}`
        }

        setInformacoes(dadosCNPJ)
      }
    } catch (error) {
      console.error('Erro ao buscar informações do CNPJ:', error)
      setInformacoes(null)
      throw error
    } finally {
      setCarregando(false)
    }
  }

  return { handleSubmit }
}
